import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import FormGroup from './FormGroup';
import FormLabel from './FormLabel';
import FormFooter from './FormFooter';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FormControlWrapper = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    explanationMessage,
    label,
    required,
    validationMessage,
    labelProps,
    footerProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "explanationMessage", "label", "required", "validationMessage", "labelProps", "footerProps"]);

  return ___EmotionJSX(FormGroup, _extends({
    ref: ref
  }, rest), ___EmotionJSX(FormLabel, _extends({
    required: required,
    error: !!validationMessage
  }, labelProps), label), children, ___EmotionJSX(FormFooter, _extends({
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }, footerProps)));
});
FormControlWrapper.propTypes = {
  children: PropTypes.node,
  explanationMessage: PropTypes.string,
  label: PropTypes.any,
  required: PropTypes.bool,
  validationMessage: PropTypes.string,
  labelProps: PropTypes.object,
  footerProps: PropTypes.object
};
export default FormControlWrapper;